import Http from '../containers/App/Http';
import store from '../containers/App/store'
import {
    setProduct,
    setFeatures,
    setSpecifications,
    setPriceTrackerData,
    setRatingTrackerData,
    setLinks,
    setCategories,
    setImages,
    setPriceExtended,
    setRatingExtended,
    setCategoriesExtended
} from "../redux/actions/productActions";

export default class Categories{

    getAllCategories(formData){
        if(typeof formData === "undefined")
            formData = new FormData();

        return Http.post("/cs/getAllCategories",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            return response;
        });
    };

}